import { GeofencesCreatePage, GeofencesRoute } from './-components';
import { createFileRoute, useRouter } from '@tanstack/react-router';

function GeofencesCreateRoute() {
  const router = useRouter();

  return (
    <GeofencesRoute
      requireGeoset
      permission="journeys/geofences/create"
      redirectTo={(params) =>
        router.buildLocation({
          to: '/workspaces/$workspaceId/geosets/$geosetId/geofences',
          params: { workspaceId: params.workspaceId, geosetId: params.geosetId ?? '' },
        }).href
      }
    >
      <GeofencesCreatePage />
    </GeofencesRoute>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/geosets/$geosetId/geofences/new')({
  component: GeofencesCreateRoute,
});
